import { useSnapshot } from 'valtio';
import { projectStore } from '../model/project-store';

export function getProjectId() {
  return projectStore.projectId;
}

/**
 * 获取当前项目 ID (valtio 全局状态)
 */
export function useProjectId() {
  const snap = useSnapshot(projectStore);
  return snap.projectId;
}
